export default __webpack_public_path__ + "static/media/003.f892fa9d.jpg";